import { Directive, ElementRef, HostListener, input } from "@angular/core";

@Directive({
    "selector": "[pcpNumberOnly]",
    standalone: true
})
export class NumberOnlyDirective {

    readonly preventLeadingZero = input<boolean>(false);
    // Allow decimal numbers. The \. is only allowed once to occur
    private regex: RegExp = new RegExp(/^[0-9]*$/g);

    // Allow key codes for special events. Reflect :
    // ArrowLeft, arrowright, backspace, enter, and delete
    private specialKeys: string[] = ["ArrowLeft", "ArrowRight", "Backspace", "Enter", "Delete"];

    constructor (private el: ElementRef) {
    }

    @HostListener("keydown", ["$event"])
    onKeyDown (event: KeyboardEvent) {
        // Allow special keys from specialKeys array above
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        const current: string = this.el.nativeElement.value;
        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        const next: string = current.concat(event.key);
        if ((next && !String(next).match(this.regex)) || (next && this.preventLeadingZero() && next === "0")) {
            event.preventDefault();
        }
    }
}
